import React from "react";
import { useSelector } from "react-redux";
import MeetingDetailsContent from "@client.components/Charts/ChartWithDetailedTooltip/MeetingDetailsContent";
import { makeInsightEventResponses, makeInsightEvents } from "../reducer";
import "./InsightsModalContent.scss";
import PropTypes from "prop-types";
import MeetingResponseContent from "@client.pages/Reports/Meetings/MeetingResponseContent";
import UserNotificationTypes from "@client.enums/userNotificationTypes";

const InsightsModalContent = (props) => {
  const insightEvents = useSelector(makeInsightEvents);
  const insightEventResponses = useSelector(makeInsightEventResponses);

  return props.data.type === UserNotificationTypes.LowAttendance ? (
    <MeetingResponseContent rowData={insightEventResponses} meetings={[]} />
  ) : (
    <MeetingDetailsContent 
      meetings={insightEvents.data} 
      details={props.description} 
      isLoading={insightEvents.load} 
    />
  )
};

InsightsModalContent.propTypes = {
  description: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default InsightsModalContent;
